<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="'编辑账户运营负责人-'+account.user_name"
        width="800px"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose">
        <div class="tool-bar">
            <el-button type="primary" @click="addNewYY">添加运营</el-button>
        </div>
        <div style="width: 90%;margin:0 auto;" v-if="dataList.length>0">
            <el-table
                :max-height="250"
                v-loading="dataLoading"
                :data="dataList">
                <el-table-column
                    align="center"
                    prop="name"
                    label="运营">
                    <template slot-scope="scope">
                        <div v-if="scope.row.id=='-1'">
                            <ESelect v-model="formItem.user_id" filterable clearable placeholder="请选择">
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </ESelect>
                        </div>
                        <div v-else>
                            {{scope.row.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="date"
                    label="负责开始时间">
                    <template slot-scope="scope">
                        <div v-if="scope.row.id=='-1'">
                            <el-date-picker
                                v-model="formItem.operation_time"
                                value-format="yyyyMMdd"
                                :picker-options="pickerOptions"
                                type="date"
                                style="width: 200px"
                                placeholder="选择日期">
                            </el-date-picker>
                        </div>
                        <div v-else>
                            {{scope.row.operation_time}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="action"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.id=='-1'" size="mini" type="primary" :loading="submitLoading" @click="handleSubmit(scope.row)">保存</el-button>
                        <el-button size="mini" type="danger" @click="deleteYY(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/mediaAccount.js';
    import utils from '@/libs/utils';
    import matomo from '@/utils/matomo.js'
    export default {
        name: "SingleYYModal",
        components:{

        },
        props:{
            account:{
                required:true,
                type:[Object],
            },
        },
        data() {
            return {
                submitLoading:false,
                dataLoading:false,
                dialogVisible: false,
                formItem: {
                    user_id:'',
                    operation_time:new Date(),
                },
                userList: [],
                dataList:[],
                isEditing:false,
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },

            }
        },
        computed: {},
        methods: {
            handleClose() {
                matomo.trackEvent('媒体账户绑定', '点击', '列表(设置运营-关闭)');
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.dialogVisible = true;
                this.getUserList();
                this.$nextTick(()=>{
                    this.getYYHistory();
                })
            },
            resetForm() {
                this.formItem.user_id = '';
                this.formItem.operation_time = new Date();
                this.isEditing = false;
            },
            getUserList(){
                API.getYYUserList().then(res => {
                    this.userList = res.data || [];
                }, (err) => {
                    console.log('getYYUserList error', err);
                    this.userList = [];
                });
            },
            handleSubmit(){
                if(!this.formItem.user_id) return this.$message.error('请选择运营负责人');
                if(!this.formItem.operation_time) return this.$message.error('请选择负责开始时间后再保存');

                let companyData = this.account.plat_id + '-' + this.account.company_id;

                let data = {
                    user_id:this.formItem.user_id,
                    operation_time:utils.formatDate(this.formItem.operation_time,'YYYYMMDD'),
                    plat_company:[companyData],
                    cover:'0',
                };

                this.submitLoading = true;
                API.setYY(data).then(res => {
                    this.$message.success(res.info || '操作成功');
                    this.isEditing = false;
                    this.submitLoading = false;
                    this.getYYHistory();
                    this.resetForm();
                    this.$emit('update');
                }, (err) => {
                    console.log('setYY single error', err);
                    if(err.code==0){
                        let errData = err.data||{
                            same_time: [],
                            same_user_time: [],
                        };
                        let errSameUserTime = errData.same_user_time||[];
                        let errSameTime = errData.same_time||[];
                        if(errSameUserTime.length>0){
                            // 成员 与 日期都重复时
                            this.$message.error('该成员在该时间已存在');
                            this.formItem.user_id = '';
                            this.formItem.operation_time = '';
                        }else if(errSameTime.length>0){
                            let errInfo = `该日期目前负责人为【${errSameTime[0].name}】，确认要覆盖吗？`;
                            this.$messageBox.confirm(errInfo, '提示', {
                                closeOnPressEscape:false,
                                confirmButtonText: '覆盖',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                data.cover = '1';
                                API.setYY(data).then(res => {
                                    this.$message.success(res.info || '操作成功');
                                    this.resetForm();
                                    this.$emit('update');
                                    this.getYYHistory();
                                }, (err) => {
                                    console.log('setYY single error', err);
                                    this.$message.error(err.info || '操作失败');
                                    this.submitLoading = false;
                                });
                            }).catch(() => {

                            });
                        }else{
                            this.$message.error(err.info || '操作失败');
                        }
                    }else{
                        this.$message.error(err.info || '操作失败');
                    }
                    this.submitLoading = false;
                });
            },
            getYYHistory(){
                this.dataLoading = true;
                API.getYYHistory({
                    plat_id:this.account.plat_id,
                    company_id:this.account.company_id,
                }).then(res => {
                    this.dataList = res.data || [];
                    this.dataLoading = false;
                }, (err) => {
                    console.log('getYYHistory error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                });
                this.resetForm();
            },
            addNewYY(){
                if(this.isEditing){
                    return this.$message.error('存在正在添加的数据，请先保存后再添加');
                }
                this.dataList.unshift({
                    id:'-1',
                    name:'',
                    date:'',
                });
                this.formItem.operation_time = new Date();
                this.isEditing = true;
            },
            deleteYY(row){
                if(row.id=='-1'){
                    this.dataList.splice(0,1);
                    this.resetForm();
                    return this.isEditing = false;
                }else{
                    this.$messageBox.confirm(`确认删除运营【${row.name}】吗？`, '提示', {
                        closeOnPressEscape:false,
                        confirmButtonText: '确认删除',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        API.deleteYYLog({
                            operation_id:row.operation_id,
                        }).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.$emit('update');
                            this.getYYHistory();
                        }, (err) => {
                            console.log('deleteYYLog error', err);
                            this.$message.error(err.info || '操作失败');
                        });
                    }).catch(() => {

                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
